<h1 mat-dialog-title class="col-12 send-email-dialogTitle">{{data.dialogTitle}}</h1>


<div mat-dialog-content>
  <mat-radio-group aria-label="Select an option" [(ngModel)]="data.selectedOption">
    <mat-radio-button value="1" class="send-email-inputs" (change)="checkifDisabled($event)">My email <b>({{data.myEmail}})</b></mat-radio-button>
    <br />
    <mat-radio-button value="2" class="send-email-inputs"(change)="checkifDisabled($event)">Send to another email:</mat-radio-button>
  </mat-radio-group>
  <br />
  <form [formGroup]="userEmails" *ngIf ="!isDisabled">

    <!--<mat-form-field class="col-12">
    <input [class.is-invalid]="primEmail.invalid && primEmail.touched" type="email" matInput placeholder="Enter the new email address"
           formControlName="primaryEmail" disabled="{{data.selectedOption != 2}}" [(ngModel)]="data.newEmail" class="send-email-inputs" />
  </mat-form-field>-->

    <mat-form-field class="col-12">
      <input [class.is-invalid]="primEmail.invalid && primEmail.touched" type="email" matInput placeholder="Enter the new email address"
             formControlName="primaryEmail"  [(ngModel)]="data.newEmail" class="send-email-inputs" />
    </mat-form-field>


      <div *ngIf="(primEmail.invalid && primEmail.touched) || primEmail.dirty">
        <small *ngIf="primEmail.errors?.required" class="text-danger">Primary email is required</small>
        <small *ngIf="primEmail.errors?.pattern" class="text-danger">Please provide a valid email address</small>
      </div>

  

    <!--<input matInput placeholder="Enter the new email address" type="email" formControlName="inputEmail"
  disabled="{{data.selectedOption != 2}}"
  [(ngModel)]="data.newEmail" class="send-email-inputs">-->

  </form>
</div>


<!--<mat-form-field [formGroup]="userEmails" class="col-12">
  <input [class.is-invalid]="primEmail.invalid && primEmail.touched" type="email" matInput placeholder="Enter the new email address"
         formControlName="primaryEmail" disabled="{{data.selectedOption != 2}}" [(ngModel)]="data.newEmail" class="send-email-inputs" />

  <div *ngIf="(primEmail.invalid && primEmail.touched) || primEmail.dirty">
    <small *ngIf="primEmail.errors?.required" class="text-danger">Primary email is required</small>
    <small *ngIf="primEmail.errors?.pattern" class="text-danger">Please provide a valid email address</small>
  </div>


</mat-form-field>-->
<div class="col-12 mb-4 mt-4">
  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="onClickCancel()" class="send-email-dialogCancelButton">Cancel</button>
    <button mat-raised-button color="primary" (click)="onClickSend()" cdkFocusInitial class="send-email-dialogSaveButton">Send</button>
  </mat-dialog-actions>
</div>
